import { render, staticRenderFns } from "./AddParentModal.vue?vue&type=template&id=ce8bc308"
import script from "./AddParentModal.vue?vue&type=script&lang=js"
export * from "./AddParentModal.vue?vue&type=script&lang=js"
import style0 from "./AddParentModal.vue?vue&type=style&index=0&id=ce8bc308&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports